// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2u_ys","select":"Header_select__2MWyj","clinic":"Header_clinic__1X0cU"};